import { registerCapability } from '../../platform/capability-registry';
import { HealthCheckBlock } from './HealthCheckBlock';
import { HEALTH_CHECK_FIELD_KEY_LIST } from './fieldKeys';
import { resolveHealthCheckPaths } from './resolvePaths';
import type { HealthCheckBlockOptions } from './types';

registerCapability<HealthCheckBlockOptions>({
  key: 'health-check',
  fields: [...HEALTH_CHECK_FIELD_KEY_LIST],
  actions: [],
  component: HealthCheckBlock,
  defaultPaths: () => resolveHealthCheckPaths(),
  resolvePaths: (_prefix, options) => resolveHealthCheckPaths(undefined, options),
});
